import { LinkButton } from '../../../../components/form';
import type { LotteryEventBranch } from '../../types';
import styles from './CampaignInduction.module.scss';

export interface CampaignInductionProps {
  lotteryEventBranches: Array<LotteryEventBranch>;
}

function CampaignInduction({ lotteryEventBranches }: CampaignInductionProps) {
  const firstBranchId = lotteryEventBranches[0].id;

  return (
    <div className={styles.componentStyle}>
      <p className='text-small'>現在、シリアルコードを持っているユーザー限定で参加できるキャンペーンくじを開催中！</p>
      <div className='mt-small'>
        <div className={styles.drawButton}>
          <LinkButton color='primary' href={`/campaign-lotteries/${firstBranchId}`}>
            <div className='text-center'>
              シリアルコードを使って
              <br />
              キャンペーンくじにチャレンジする
            </div>
          </LinkButton>
        </div>
      </div>
    </div>
  );
}

export default CampaignInduction;
